import { Injectable } from '@angular/core';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { map } from 'rxjs/operators';
import { IResponseInfo } from '../http/http.data';
import { Support } from './models/support.model';
import { Observable } from 'rxjs';

export const SUPPORT_ACCEPT_VERSION = '2.0.0';

@Injectable()
export class SupportDataService {
  private _url = '/help_center';
  protected headers = {
    [ACCEPT_VERSION_HEADER]: SUPPORT_ACCEPT_VERSION,
  };

  constructor(private _authHttpService: AuthHttpService) {}

  fetchSupport(): Observable<Support> {
    return this._authHttpService
      .get(this._url, {}, this.headers)
      .pipe(map(({ body, ..._ }: IResponseInfo) => new Support(body)));
  }
}
